export interface IConnectState {
  readonly connect?: any;
}

export interface IConnectSelector extends IConnectState {
  readonly connect?: any;
}

export enum ConnectActionTypes {
  SET_CONNECT_INFORMATION = 'redux-app/connect/SET_CONNECT_INFORMATION',
  RESET_CONNECT_INFORMATION = 'redux-app/connect/RESET_CONNECT_INFORMATION',
}

export default null;
